import React from "react";

import { RadioGroup as CobaltRadioGroup, Radio as CobaltRadio } from "Cobalt/RadioGroup";
import { RadioGroup as CommonRadioGroup, Radio as CommonRadio } from "Common/RadioGroup";

import { useThemeContext } from "./Context";

export type RadioProps = {
  name: string;
  value: string;
  checked: boolean;
  inline?: boolean;
  /*
   * Note: There is an inconsistency between the onChange
   * prop types in controlled/uncontrolled variants
   */
  onChange?: (value: Event | string) => void;
  children?: React.ReactNode;
  disabled?: boolean;
};

export type RadioGroupProps = {
  disabled?: boolean;
  inline?: boolean;
  options: Record<string, React.ReactNode> | Array<[string, React.ReactNode]>;
  id: string;
  name: string;
  value?: string;
  onChange?: (arg0: Event) => void;
  children?: React.ReactNode;
};

export const RadioGroup = (props: RadioGroupProps) => {
  const { cobalt, intuit } = useThemeContext();

  const RadioGroupComponent = cobalt && !intuit ? CobaltRadioGroup : CommonRadioGroup;
  return <RadioGroupComponent {...props} />;
};

export const Radio = (props: RadioProps) => {
  const { cobalt, intuit } = useThemeContext();

  const RadioComponent = cobalt && !intuit ? CobaltRadio : CommonRadio;
  return <RadioComponent {...props} />;
};
